// Options:
// type: 'default', 'success', 'warning', 'danger'
// includeCloseButton: true, false
// autoRemoveTime: Any time in milliseconds
(function (window) {
    'use strict';

    window.toast = function (options) {
        if (!options.message) {
            throw new Error('Toast.js - You need to set a message to display');
            return;
        }

        options.type = options.type || 'default';
        options.autoRemoveTime = options.autoRemoveTime || 10000;

        function run() {
            var toastEl = document.createElement('div');

            if (!document.querySelector('.toastjs-container')) {
                var toastContainerEl = document.createElement('div');
                toastContainerEl.classList.add('toastjs-container');
                toastContainerEl.setAttribute('role', 'alert');
                document.body.appendChild(toastContainerEl);
            }

            toastEl.classList.add('toastjs');
            toastEl.classList.add(options.type);
            toastEl.innerHTML = '<p>' + options.message + '</p>';
            document.querySelector('.toastjs-container').appendChild(toastEl);
            toastEl.addEventListener('click', function () {
                removeToast(toastEl);
            });
            setTimeout(function () {
                toastEl.setAttribute('aria-hidden', false);
            }, 50);

            if (options.autoRemoveTime && typeof options.autoRemoveTime === 'number') {
                setTimeout(function () {
                    removeToast(toastEl);
                }, options.autoRemoveTime);
            }
        }

        function removeToast(toast) {
            toast.setAttribute('aria-hidden', true);
            setTimeout(function () {
                document.querySelector('.toastjs-container').removeChild(toast);
            }, 350);
        }

        if (typeof options.message === 'string') {
            run();
        } else if (typeof options.message.then === 'function') {
            options.message.then(function (text) {
                options.message = text;
                run();
            }, function (test) {
                options.message = text;
                run();
            });
        }
    }
})(window);